var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotPublished(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 40.5,
    r: 25.5,
    fill: "#E1E9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 22.75H51.75M30 30V37.25M30 44.5H30.0242M17.9167 8.25V13.0833M42.0833 8.25V13.0833M15.9833 51.75H44.0167C46.7236 51.75 48.0772 51.75 49.111 51.2232C50.0204 50.7599 50.7599 50.0204 51.2232 49.111C51.75 48.0772 51.75 46.7236 51.75 44.0167V20.8167C51.75 18.1097 51.75 16.7563 51.2232 15.7224C50.7599 14.8129 50.0204 14.0735 49.111 13.6101C48.0772 13.0833 46.7236 13.0833 44.0167 13.0833H15.9833C13.2764 13.0833 11.9229 13.0833 10.889 13.6101C9.97958 14.0735 9.24018 14.8129 8.77681 15.7224C8.25 16.7563 8.25 18.1097 8.25 20.8167V44.0167C8.25 46.7236 8.25 48.0772 8.77681 49.111C9.24018 50.0204 9.97958 50.7599 10.889 51.2232C11.9229 51.75 13.2764 51.75 15.9833 51.75Z",
    stroke: "#70707A",
    strokeWidth: 4.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotPublished);
export default __webpack_public_path__ + "static/media/notPublished.b1aa412590afb83f970408e24df25894.svg";
export { ForwardRef as ReactComponent };